import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { DashboardTypes } from 'features/Codes'
import { createSlice } from '@reduxjs/toolkit'

const OnOffAPIs = {
  [DashboardTypes.CAMPAIGN]: {
    ON: api.dashboard.patchCampaignsOn,
    OFF: api.dashboard.patchCampaignsOff,
  },
  [DashboardTypes.AD_GROUP]: {
    ON: api.dashboard.patchAdGroupsOn,
    OFF: api.dashboard.patchAdGroupsOff,
  },
  [DashboardTypes.KEYWORD]: {
    ON: api.dashboard.patchKeywordsOn,
    OFF: api.dashboard.patchKeywordsOff,
  },
  [DashboardTypes.CREATIVE]: {
    ON: api.dashboard.patchCreativeLinksOn,
    OFF: api.dashboard.patchCreativeLinksOff,
  },
}
export const updateOnOffStatus = createAxiosThunk(
  'dashboard/updateOnOffStatus',
  ({ type, status, ids }) => OnOffAPIs[type][status]({ ids })
)

const dashboardOnOffSlice = createSlice({
  name: 'dashboard/operation/delete',

  initialState: {
    isSubmitting: false,
  },

  extraReducers: builder => {
    builder.addCase(updateOnOffStatus.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateOnOffStatus.rejected, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateOnOffStatus.fulfilled, state => {
      state.isSubmitting = false
    })
  },
})

export default dashboardOnOffSlice.reducer
